<template>
    <div>
        <!--查询条件start-->
        <el-form :inline="true" :model="query" class="query-form" size="small">
            <el-form-item class="query-form-item">
                <el-select v-model="query.classifyid" placeholder="请选择分类" clearable @change="onSubmit">
                    <el-option v-for="(item, index) in comClassifys" :key="index" :label="item.classifytitle" :value="item.classifyid">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-select v-model="query.senceId" placeholder="请选择场景" clearable @change="onSubmit">
                    <el-option v-for="(item, index) in comSence" :key="index" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>


            <el-form-item class="query-form-item">
                <el-select v-model="query.commoditytype" clearable placeholder="请选择上下架">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item class="query-form-item">
                <el-input v-model="query.commodityname" placeholder="请输入商品名称" prefix-icon="el-icon-search" @keyup.enter.native="onSubmit" clearable></el-input>
            </el-form-item>
            <el-form-item class="query-form-item" >
                <el-select
                    v-model="query.brandid"
                    placeholder="请选择品牌"
                    style="width:150px"
                    @change="onSubmit"
                    clearable
                >
                    <el-option
                        v-for="(item,index) in comBrands"
                        :key="index"
                        :label="item.brandtitle"
                        :value="item.brandid"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
                <el-button type="primary" icon="el-icon-edit" @click.native="Edit(null)">添加
                </el-button>
<!--                <el-button type="primary" @click="exportExcel()">导出数据 </el-button>-->
<!--                <el-button type="primary" @click="downModel()">模板下载 </el-button>-->
                <!-- <el-upload
                    class="upload-btn"
                    :action="uploadAction"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :on-error="handleAvatarError"
                    :before-upload="uploadLoadings"
                    accept=".xls, .xlsx"
                    multiple
                >
                  <el-button type="default">导入数据</el-button>
                </el-upload> -->
                <el-button type="primary" @click="dialogImportGoodsVisible = true">导入商品数据 </el-button>
                <el-button type="primary" @click="dialogExportGoodsVisible = true">导出商品数据 </el-button>
<!--                <el-button type="primary" @click="dialogImportInventoryVisible = true">导入库存数据 </el-button>-->
<!--                <el-button type="primary" @click="">导出库存数据 </el-button>-->
            </el-form-item>
        </el-form>

        <!-- 导入商品弹出层 -->
        <el-dialog title="批量导入商品" width="400px" :visible.sync="dialogImportGoodsVisible" :before-close="handleClose">
          <div class="export-goods">
            <div class="export-title">
            </div>
            <div class="export-main">
              <span>1、请选择您需要添加的<span>商品分类</span><span>&场景分类</span></span>
              <div class="export-main-select">
                <el-select
                  size="mini"
                  v-model="selectGoodsValue"
                  placeholder="全部商品分类" >
                  <el-option
                    v-for="(item, index) in comClassifys"
                    :key="index"
                    :label="item.classifytitle"
                    :value="item.classifyid">
                  </el-option>
                </el-select>
                <el-select
                  size="mini"
                  v-model="selectSceneValue"
                  placeholder="全部场景分类">
                  <el-option
                    v-for="(item, index) in comSence"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <span>2、请选择您要导入的方式</span>
              <div class="export-main-type">
                <div class="export-main-type-add" :class="{'export-main-type-active':exportType==1}" @click="addNewData">
                  <i class="el-icon-circle-plus-outline"></i>
                  <span >添加新数据</span>
                </div>
                <div class="export-main-type-add" :class="{'export-main-type-active':exportType==2}" @click="upNewData">
                  <i class="el-icon-refresh"></i>
                  <span>更新现有数据</span>
                </div>
              </div>
              <div class="export-main-upload">
                  <el-button type="primary" @click="downModel()">下载数据模板</el-button>
                  <div style="margin-top: 20px;margin-bottom: 15px;text-align: center" class="export-export-upload">
                      <el-upload
                          class="upload-btn"
                          action=""
                          :show-file-list="false"
                          :http-request="uploadFn"
                          :on-success="handleAvatarSuccess"
                          :on-error="handleAvatarError"
                          :before-upload="uploadLoadings"
                          accept=".xls, .xlsx"
                          multiple
                      >
                          <el-button size="small" type="success">上传</el-button>
                      </el-upload>
                  </div>
              </div>
            </div>
            <span>3、批量导入结果</span>
            <div class="export-result-info1">
                <span style="color: #67C23A;" v-show="hideWorsd">导入成功！共导入{{this.total.total}}条数据，成功{{this.total.successTotal}}条数据！</span>
                <span style="color: #F56C6C;text-decoration: underline;cursor: pointer;" v-show="hideWorsd1" @click="errDownload">导入失败！共导入{{this.total.total}}条数据，成功{{this.total.successTotal}}条数据，失败{{this.total.errorTotal}}条数据！</span>
            </div>
              <div style="text-align: center;">
                  <el-button type="primary" @click="ok">确定</el-button>
              </div>
          </div>
        </el-dialog>
        <!-- 导入商品弹出层 -->

        <!-- 导出商品弹出层 -->
        <el-dialog title="批量导出商品" width="400px" :visible.sync="dialogExportGoodsVisible" :before-close="handleClose1">
          <div class="export-goods">
            <div class="export-title">
            </div>
            <div class="export-main">
              <span>1、请选择您需要添加的<span>商品分类</span><span>&场景分类</span></span>
              <div class="export-main-select">
                <el-select
                  size="mini"
                  v-model="selectGoodsValue"
                  placeholder="全部商品分类" >
                  <el-option
                    v-for="(item, index) in comClassifys"
                    :key="index"
                    :label="item.classifytitle"
                    :value="item.classifyid">
                  </el-option>
                </el-select>
                <el-select
                  size="mini"
                  v-model="selectSceneValue"
                  placeholder="全部场景分类">
                  <el-option
                    v-for="(item, index) in comSence"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="export-export-upload"><el-button type="success"  @click="downloadExcel">下载</el-button></div>
            <span v-if="this.downloadExcelList.totalNum != null">2、批量导出结果</span>
            <div class="export-result-info">
                <span style="color: #67C23A;"  v-if="this.downloadExcelList.successNum >=0">导出成功!共导出{{this.downloadExcelList.totalNum}}条数据，成功{{this.downloadExcelList.successNum}}条数据！</span>
                <span style="color: #F56C6C" v-if="this.downloadExcelList.errorNum >0">导出失败！共导出{{this.downloadExcelList.totalNum}}条数据，成功{{this.downloadExcelList.successNum}}条数据，数据失败{{this.downloadExcelList.errorNum}}条数据！</span>
            </div>
          </div>
        </el-dialog>
        <!-- 导出商品弹出层 -->

        <!-- 导入库存数据弹出层 -->
<!--        <el-dialog title="批量导入库存" width="400px" :visible.sync="dialogImportInventoryVisible">-->
<!--          <div class="export-goods">-->
<!--            <div class="export-title">-->
<!--            </div>-->
<!--            <div class="export-Inventory">-->
<!--              <span>1、请导出目前库存数据:</span>-->
<!--              <span class="export-Inventory-btn">导出目前库存数据</span>-->
<!--            </div>-->
<!--            <span>2、请导入更新的库存数据:</span>-->
<!--            <div style="margin-top: 20px;margin-bottom: 15px;" class="export-export-upload"><el-button type="success">上传</el-button></div>-->
<!--            <span class="export-Inventory-info" ><i class="el-icon-warning-outline" style="margin-left: 5px;"></i>需导出目前数据再修改上传</span>-->
<!--            <span>3、批量导出结果</span>-->
<!--            <div class="export-result-info">-->
<!--                <span style="color: #67C23A;">导出成功!共导入{{123}}条数据，成功{{123}}数据！</span>-->
<!--                <span style="color: #F56C6C">导出失败！共导入{{1}}条数据，失败{{122}}条数据！</span>-->
<!--            </div>-->
<!--          </div>-->
<!--        </el-dialog>-->
        <!-- 导入库存数据弹出层 -->

        <!--列表start-->
        <el-table ref="multipleTable" v-loading="loading" :data="list" :header-cell-style="{ background: '#F4F4F5', color: '#606266' }" @selection-change="handleSelectionChange" border>
            <el-table-column type="selection" width="50" fixed />
            <el-table-column label="缩略图" prop="commodityurl" width="80" align="center">
                <template slot-scope="scope">
                    <img :src="scope.row.commodityurl" style="width: 50px;height: 50px;" />
                </template>
            </el-table-column>
            <el-table-column label="序列号"  prop="commoditynum" align="center" />
            <el-table-column label="商品名称" prop="commodityname" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="分类" prop="classifytitle" align="center" />
            <el-table-column label="价格" align="center" prop="specprice">
                <template slot-scope="scope">
                    <span>{{scope.row.specprice | price(scope.row.specprice)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="品牌" align="center" prop="brandtitle"/>
            <el-table-column label="产品编码" prop="commoditysort" align="center" />
            <el-table-column label="操作" width="350" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click.native="godetail(scope.row.commodityid)">查看</el-button>
                    <el-button type="primary" size="mini" @click.native="Edit(scope.row.commodityid)">编辑</el-button>
                    <el-button type="danger" size="mini" @click.native="handleDel(scope.row.commodityid)">删除</el-button>
                    <el-button v-if="scope.row.commoditytype == 0" size="mini" @click.native="
                        lowershelf(scope.row.commodityid,scope.row.commoditytype)">下架
                    </el-button>
                    <el-button v-if="scope.row.commoditytype == 1" size="mini" @click.native="
                        lowershelf(scope.row.commodityid,scope.row.commoditytype)">上架
                    </el-button>
                    <el-button type="primary" size="mini" @click.native="copy(scope.row.commodityid)">复制</el-button>
                </template>
            </el-table-column>
            <el-table-column label="推荐商品" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="
                        showRecommend(scope.row.commodityid,scope.row.recomecount,scope.$index)">
                        {{ scope.row.recomecount }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--列表end -->

        <!--全选删除start-->
        <div class="left-container">
            <el-button type="danger" size="small" @click="delGroup()">删除已选</el-button>
            <el-button type="danger" size="small" @click="batchUp">批量上架</el-button>
            <el-button type="danger" size="small" @click="batchDown">批量下架</el-button>
            <transition name="el-fade-in-linear">
                <el-button size="small" @click="toggleSelection()" v-show="cancelToggle">取消选择</el-button>
            </transition>
        </div>
        <!--全选删除end-->

        <!--分页模块start-->
        <el-pagination class="pagination-container" background :page-size="query.pageSize" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total,sizes,prev, pager, next, jumper" :current-page="query.currentPage" :page-sizes="[10, 20, 30, 50]" :total="totalNumber"></el-pagination>
        <!--分页模块end-->

        <!--新增/编辑弹框-->
        <edit ref="editModal" @getList="getList"></edit>

        <!--查看弹框-->
        <detail ref="detail"></detail>

        <!--推荐列表-->
        <recommend ref="recommend" @addcount="addcount" @reducecount="reducecount"></recommend>
    </div>
</template>
<script>
import axios from "axios";
import {
    getList,
    getAllSence,
    getClassifyAll,
    deleteCommodity,
    upDownCommodity,
    getBrands,
    copyCommodity,
    batchUpDownCommodity,
    exportVer4,
    downloadTemplateV4
} from "../../api/product/product";
import Tinymce from "../../components/Tinymce/index";
import edit from "./edit";
import detail from "./detail";
import recommend from "./recommend";
import { BASE_URL } from "../../config/app";
import store from "@/store";
export default {
    components: {
        Tinymce,edit,detail,recommend
    },
    data() {
        return {
            //导入商品弹出层开关
            dialogImportGoodsVisible:false,
            //导出商品弹出层开关
            dialogExportGoodsVisible:false,
            selectGoodsValue: '',
            selectSceneValue:'',
            query: {
                //查询条件
                currentPage: 1,
                pageSize: 10,
                classifyid: "", //分类
                senceId: "", //场景
                commodityname: "", //商品名称
                commoditytype: "",//上下架 0上架 1下架
            },

            options: [{
                value: 0,
                label: '上架'
            }, {
                value: 1,
                label: '下架'
            }],

            createTime: [], //选择日期时需要的model
            list: [], //列表集合
            totalNumber: 0, //分页总页数
            loading: true, //列表加载
            cancelToggle: false, //列表是否全选
            multipleSelection: [], //多选集合
            comClassifys:[], //分类合集
            comSence: [], //场景
            commodityid: "", //当前商品id
            toindex: 0, //下标
            //uploadAction :BASE_URL +"/commodityManage/uploadV4",
            //uploadAction :BASE_URL +"/commodityManage/uploadV4?classifyid="+ 2 +"&senceId="+ 2 +"&activeFlag="+ 1, // 导入url
            //window.location.href = BASE_URL + "/commodityManage/export?classifyid="+this.query.classifyid+"&senceId="+this.query.senceId+"&commodityname="+this.query.commodityname;
            comBrands:[], //品牌
            downloadExcelList:[],//商品数据
            exportType: 1,
            total: [],
            hideWorsd: false,
            hideWorsd1: false
            //uploadAction :BASE_URL +"/commodityManage/uploadV4?classifyid="+ that.selectGoodsValue +"&senceId="+ this.selectSceneValue +"&activeFlag="+ this.exportType, // 导入url
        };
    },


    methods: {
        /*获取列表事件*/
        regetlist(){
              this.query.currentPage=this.query.currentPage-1
              this.getList();
            },
        getList() {
            this.loading = true;
            getList(this.query)
                .then((response) => {
                    this.loading = false;
                    if (response.code != 0) {
                        this.$message.error(response.message);
                        return false;
                    }
                    if (this.query.currentPage > 1 && response.data.list.length<1) {
                            this.regetlist();
                        } else {
                          this.list = response.data.list || [];
                    this.totalNumber = response.data.totalNumber || 0;
                        }

                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                });
        },
        //导出
        exportExcel() {
            //window.location.href = "http://192.168.1.138:18080/commodityManage/export";
            window.location.href = BASE_URL + "/commodityManage/export?classifyid="+this.query.classifyid+"&senceId="+this.query.senceId+"&commodityname="+this.query.commodityname;
        },
        // 模板下载
        downModel() {
         if (this.exportType == 1) {
             this.downloadTemplateV4();
         }else if (this.exportType == 2){
             this.downloadExcel();
         }
       },
        /*列表查询条件事件*/
        onSubmit() {
            this.getList();
        },
        //加载分类
        getClassify() {
            getClassifyAll().then(response => {
                if (response.code) {
                    this.$message.error(response.message);
                }
                this.comClassifys = response.data || [];
                sessionStorage.setItem('comClassifys',JSON.stringify(response.data))
            }).catch(() => {
                this.comClassifys = [];
            });
        },
        /*查询场景*/
        getSence() {
            getAllSence().then((res) => {
                this.comSence = res.data || [];
                sessionStorage.setItem('comSence',JSON.stringify(res.data))
            });
        },

        ok(){
            this.handleClose()
        },
        //取消上传
        handleClose(){
            this.hideWorsd = false;
            this.hideWorsd1 = false;
            this.dialogImportGoodsVisible=false;
            this.selectGoodsValue='';
            this.selectSceneValue='',
            this.getList();
        },
        handleClose1(){
            this.dialogExportGoodsVisible=false;
            this.downloadExcelList = [];
            this.selectGoodsValue='';
            this.selectSceneValue='';
            this.getList();
        },
        downloadExcel() {
            let params = {
                classifyid: this.selectGoodsValue,
                senceId: this.selectSceneValue,
            };
            if (params.classifyid == '' || params.senceId == '' ){
                this.$message({
                    message: "请先选择商品分类和场景分类",
                    type: "warning",
                });
                return;
            }
            console.log("分类",this.selectGoodsValue)
            console.log("场景",this.selectSceneValue)
            exportVer4(params).then((res) => {
                this.downloadExcelList = res.data || [];
                if (this.downloadExcelList.successNum>0){
                    window.location.href = this.downloadExcelList.downloadUrl;
                }
            });
            this.selectGoodsValue = ''
            this.selectSceneValue = ''
        },

        //下载空模板
        downloadTemplateV4() {
            let params = {
                classifyid: this.selectGoodsValue,
                senceId: this.selectSceneValue,
            };
            if (params.classifyid == '' || params.senceId == '' ){
                this.$message({
                    message: "请先选择商品分类和场景分类",
                    type: "warning",
                });
                return;
            }
            console.log("分类",this.selectGoodsValue)
            console.log("场景",this.selectSceneValue)
            downloadTemplateV4(params).then((res) => {
                this.downloadExcelList = res.data || [];
                    window.location.href = this.downloadExcelList.downloadUrl;
            });
            this.selectGoodsValue = ''
            this.selectSceneValue = ''
        },


        addNewData(){
            this.exportType = 1;
        },
        upNewData(){
            this.exportType = 2;
        },
        // 错误数据下载
        errDownload() {
            window.location.href = this.total.url;
        },

        /*刷新*/
        onRest() {
            //刷新事件需要重置查询条件
            this.createTime = [];
            this.query = {
                currentPage: 1,
                pageSize: 10,
            };
            this.getList();
        },
        /*显示推荐列表弹框*/
        showRecommend(commodityid, count, index) {
            this.toindex = index;
            this.$refs.recommend.openDialog(commodityid, count)
        },
        /*更新推荐数量*/
        addcount(){
            this.list[this.toindex].recomecount =this.list[this.toindex].recomecount + 1;
        },
        reducecount(){
            this.list[this.toindex].recomecount =this.list[this.toindex].recomecount - 1;
        },
        /*显示查看弹框*/
        godetail(id){
            // this.$refs.detail.openDialog(id)
            this.$router.push({
                path:'/product/prview',
                query:{
                    id:id
                }
            })
        },
        /*显示 -新增或者编辑弹框*/
        Edit(id) {
            this.$refs.editModal.openDialog(id,this.comBrands)
        },
        /*点击页数*/
        handleCurrentChange(val) {
            this.query.currentPage = val;
            this.getList();
        },
        /*选择每页条数【10,20,30,40,50】*/
        handleSizeChange(val) {
            this.query.pageSize = val;
            this.getList();
        },

        /*取消全选事件*/
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },

        /*列表复选框选择事件*/
        handleSelectionChange(val) {
            this.multipleSelection = val;
            if (val == "") {
                this.cancelToggle = false;
                return;
            }
            this.cancelToggle = true;
        },

        /*全选删除事件*/
        delGroup() {
            var ids = this.multipleSelection.map((item) => item.commodityid).join();
            if (ids == "") {
                this.$message({
                    message: "请先选择",
                    type: "warning",
                });
                return;
            }
            this.handleDel(ids);
        },
        /*全选上架事件*/
        batchUp(){
            var ids = this.multipleSelection.map((item) => item.commodityid).join();
            if (ids == "") {
                this.$message({
                    message: "请先选择",
                    type: "warning",
                });
                return;
            }
            this.handleUpDown(ids, 1);
        },
        /*全选下架事件*/
        batchDown(){
            var ids = this.multipleSelection.map((item) => item.commodityid).join();
            if (ids == "") {
                this.$message({
                    message: "请先选择",
                    type: "warning",
                });
                return;
            }
            this.handleUpDown(ids, 0);
        },
        /*批量上下架*/
        handleUpDown(ids, type) {
            let str = type == 0 ? "下架" : "上架";
            if (ids) {
                this.$confirm("确认要" + str + "该服务?", "提示", {
                    type: "warning",
                }).then(() => {
                    var params = new URLSearchParams();
                    params.append("ids", ids);
                    params.append("commoditytype", type);
                    batchUpDownCommodity(params).then((response) => {
                        if (response.code != 0) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.$message.success("操作成功");
                        this.getList();
                    }).catch(() => {
                        this.$message.error("操作出错");
                    });
                }).catch(() => {
                    this.$message.warning("已取消");
                });
            }
        },

        /*下架*/
        lowershelf(id, type) {
            let str = type == 0 ? "下架" : "上架";
            if (id) {
                this.$confirm("确认要" + str + "该服务?", "提示", {
                    type: "warning",
                })
                    .then(() => {
                        this.loading = true;
                        var params = new URLSearchParams();
                        params.append("commodityid", id);
                        params.append("commoditytype", type);
                        upDownCommodity(params)
                            .then((response) => {
                                this.loading = false;
                                if (response.code) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success("操作成功");
                                // 刷新数据
                                this.getList();
                            })
                            .catch(() => {
                                this.$message.error("操作出错");
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            }
        },

        /*单击删除事件*/
        handleDel(ids) {
            if (ids) {
                this.$confirm("确认要删除吗?", "提示", {
                    type: "warning",
                }).then(() => {
                    deleteCommodity({ids:ids.toString()}).then((response) => {
                        if (response.code != 0) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.$message.success("删除成功");
                        this.getList();
                    }).catch(() => {
                        this.$message.error("删除出错");
                    });
                }).catch(() => {
                    this.$message.warning("已取消");
                });
            }
        },

        /*日期选择事件*/
        dateChange(val) {
            if (val == null) {
                this.query.startTime = "";
                this.query.endTime = "";
            } else {
                this.query.startTime = val[0];
                this.query.endTime = val[1];
                this.query.currentPage = 1;
            }
            this.getList();
        },
        uploadLoadings(){
            this.loading=true;
        },
        uploadFn(param){
            var file = param.file
            const formData = new FormData();
            formData.append("file",file)
            var uploadAction= BASE_URL +"/commodityManage/uploadV4?classifyid="+ this.selectGoodsValue +"&senceId="+ this.selectSceneValue +"&activeFlag="+ this.exportType;
            axios.post(uploadAction, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res=>{
                if (res.data.code) {
                    this.$message.error(res.data.message);
                    return false;
                }
                this.total = res.data.data;
                if (res.data.data.errorTotal == 0) {
                    this.hideWorsd = true;
                    this.hideWorsd1 = false;
                } else {
                    this.hideWorsd1 = true;
                    this.hideWorsd = false;
                }
                // this.$message.success("导入成功");
                this.getList();
            }).catch(error => {
                console.log('catch', error)
            })
        },
        handleAvatarSuccess(response) {
            debugger;
            if (response.code) {
                this.$message.error(response.message);
                return false;
            }
            this.total = response.data;
            if (response.data.errorTotal == 0) {
                this.hideWorsd = true;
            } else {
                this.hideWorsd1 = true;
            }
            // this.$message.success("导入成功");
            this.getList();
        },
        handleAvatarError() {
            this.$message.error("上传文件出错");
        },
        getBrand() {
            getBrands(this.query)
                .then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                    }
                    this.comBrands = response.data || [];
                    console.log("12   ",response.data);
                    setTimeout(() => {
                        this.loading = false;
                    }, 0.3 * 1000);
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                });
        },
        copy(id){
            copyCommodity({
                commodityId: id
            })
                .then((response) => {
                    console.log(response);
                    if (response.code == -1) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.$message.success("复制成功");
                    this.loading = false;
                    // this.getList();
                    this.Edit(response.data)
                })
                .catch(() => {
                    this.$message.error("复制出错");
                    this.loading = false;
                });
        }
    },

    filters: {
        price: function (myInput) {
            var val = parseInt(myInput);
            if (typeof val === "number") {
                return val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
            }
        },
    },

    created() {
        this.getClassify(); //查询分类
        this.getSence(); //查询场景
        this.getList(); //查询列表
        this.getBrand();// 查品牌
        console.log(this.uploadAction)
    },
};
</script>

<style lang="scss" scoped>
.export-goods{
  height: 100%;
}


.export-Inventory-info{
  color: orange;
  display: block;
  font-size: 12px;
  margin-bottom: 20px;
  padding-left: 80px;
}

.export-Inventory{
  margin-bottom: 20px;
}

.export-Inventory-btn{
  text-decoration: underline;
  color: blue;
  margin-left: 10px;
  cursor: pointer;
}

.export-goods .export-title{
  display: flex;
  align-items: center;
}

.export-export-upload{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 44px;
}

.export-export-upload .el-button{
  width: 100px;
}

.export-goods .export-main  {

}

.export-main-select{
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 15px;
  padding: 0 10px 0 10px;
}

.export-main-select .el-select{
  width: 160px;
}

.export-main-type{
  display: flex;
  align-items: center;
  height: 160px;
}

.export-main-type-active{
  border: 2px solid #409EFF !important;
  color: #409EFF;
}

.export-main-type-add{
  height: 120px;
  width: 120px;
  border: 2px solid #DCDFE6;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-left: 35px;
  padding: 8px;
    cursor:pointer;
}

.export-main-upload{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  margin-top: 10px;
  margin-bottom: 10px;
}

.export-main-upload .el-button{
  width: 120px;
  margin-bottom: 10px;
  margin-left: 0;
}

.export-result-info{
  height: 100px;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
}

.export-result-info1{
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    margin-bottom: 30px;
}

.export-result-info span{
  margin-top: 15px;
}

.labelClass {
    display: inline-block;
    width: 90px;
    text-align: right;
}
.query-form-item{
  width: 160px;
}
.labelMini {
    display: inline-block;
    width: 50px;
    text-align: right;
}
.showContent {
    display: inline-block;
    width: 230px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
}
.textBox {
    display: inline-block;
    max-width: 830px;
    margin-left: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
}
</style>
<style type="text/scss" lang="scss">
.el-dialog > .el-dialog__footer > .dialog-footer > .pagination-container {
    margin: 10px;
    float: none;
}

.aaa img {
    // width: 200px !important;
    // height: 200px !important;
    display: block;
    max-width: 100%;
    height: auto !important;
    margin-bottom: 10px;
    box-shadow: 0 0 7px 1px #eee;
}

.productadd .el-dialog {
    margin-top: 2vh !important;
}
</style>
